<template>
  <el-table-column :label="label" :prop="prop" class-name='datetime' :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '日時'
    },
    prop: {
      type: String,
      default: 'datetime'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.datetime {
      width: 9em;
    }
  }
  td {
    &.datetime {
      padding: 0 0.5em;
    }
  }
}
</style>
